import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const CommentUpdateContent = lazy(() => import('../../../../components/Pages/Comments/[commentId]/Update'));

export default function CommentUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Comment update`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <CommentUpdateContent />
      </Suspense>
    </Layout>
  );
}
